import React from "react";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const StyledUl = styled("ul")(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  listStyleType: "disc",
  "& li": {
    marginBottom: theme.spacing(1),
  },
}));

function SalesAgreement({ planName, durationLabel, subtotalText, vatText, totalText }) {
  return (
    <MDBox p={3}>
      <MDTypography variant="h4" fontWeight="medium" mb={2} color="info">
        MESAFELİ SATIŞ SÖZLEŞMESİ
      </MDTypography>

      {/* Taraflar */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        Taraflar
      </MDTypography>
      <MDTypography variant="body2" color="text"><strong>Satıcı (Hizmet Sağlayıcı):</strong></MDTypography>
      <MDTypography variant="body2" color="text"><strong>Unvan:</strong> LogicaDx Bilişim Danışmanlık</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Adres:</strong> Barbaros Mah. Ihlamur Blv. No: 3 İç Kapı No: 15 Ataşehir / İstanbul</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Vergi Kimlik No:</strong> 7960516854</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Web:</strong> www.logicookie.com</MDTypography>
      <MDTypography variant="body2" color="text" mb={1}><strong>E-Posta:</strong> info@logicookie.com</MDTypography>
      <MDTypography variant="body2" color="text" mb={2}>
        Elektronik ortamda üyelik sırasında bilgileri beyan edilen gerçek/tüzel kişi bundan böyle ALICI olarak anılacaktır.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 1. Tanımlar */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        1. Tanımlar
      </MDTypography>
      <StyledUl>
        <li><MDTypography variant="body2" color="text"><strong>Hizmet:</strong> LogiCookie çerez yönetimi SaaS hizmeti.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Abonelik:</strong> ALICI’nın seçtiği plan kapsamında süreli hizmet kullanımı.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Veri Koruma Mevzuatı:</strong> 6698 sayılı KVKK, AB GDPR ve ilgili ikincil düzenlemeler.</MDTypography></li>
        <li><MDTypography variant="body2" color="text"><strong>Açık Rıza:</strong> KVKK/GDPR uyarınca, bilgilendirmeye dayalı ve özgür iradeyle açıklanan rıza.</MDTypography></li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 2. Konu ve Kapsam */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        2. Konu ve Kapsam
      </MDTypography>
      <MDTypography variant="body2" color="text">
        2.1. İşbu sözleşme, ALICI’nın www.logicookie.com üzerinden sipariş verdiği LogiCookie hizmetinin satışı, ifası ve tarafların hak ve yükümlülüklerinin belirlenmesini konu alır.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 3. Hizmetin Kapsamı ve İfası */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        3. Hizmetin Kapsamı ve İfası
      </MDTypography>
      <MDTypography variant="body2" color="text">3.1. Satışa konu hizmet, LogiCookie SaaS platformuna dijital erişim yoluyla sunulur.</MDTypography>
      <MDTypography variant="body2" color="text">3.2. ALICI, seçtiği abonelik planına uygun olarak platforma erişim hakkına sahip olur.</MDTypography>
      <MDTypography variant="body2" color="text">3.3. Hizmetin ifası, ödeme onayı alındığı anda başlar.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 4. Sözleşmenin Kurulması */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        4. Sözleşmenin Kurulması
      </MDTypography>
      <MDTypography variant="body2" color="text">4.1. İşbu sözleşme, ALICI’nın elektronik ortamda onay vermesiyle kurulmuş sayılır.</MDTypography>
      <MDTypography variant="body2" color="text">4.2. İşbu sözleşmenin eki niteliğinde olan Ön Bilgilendirme Formu ALICI’ya sunulmuş ve onaylanmıştır.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 5. Abonelik ve Ödeme */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        5. Abonelik ve Ödeme
      </MDTypography>
      <MDTypography variant="body2" color="text">5.1. Abonelikler aylık veya yıllık olarak sunulur.</MDTypography>
      <MDTypography variant="body2" color="text">5.2. Abonelikler süresi dolduğunda otomatik olarak yenilenir. ALICI dilediği zaman iptal edebilir.</MDTypography>
      <MDTypography variant="body2" color="text">5.3. Deneme süresi sonunda ALICI kredi/banka kartı ile ödeme yapmazsa, üyelik askıya alınır ve hizmete erişim durdurulur.</MDTypography>
      <MDTypography variant="body2" color="text">5.4. Kredi/banka kartı bilgilerinin doğru ve güncel tutulmasından ALICI sorumludur. Yanlış/eksik bilgi nedeniyle doğacak sonuçlardan SATICI sorumlu değildir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 6. Cayma Hakkı */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        6. Cayma Hakkı
      </MDTypography>
      <MDTypography variant="body2" color="text">6.1. Hizmet, Mesafeli Sözleşmeler Yönetmeliği m.15/1-ğ kapsamında elektronik ortamda anında ifa edildiğinden cayma hakkı bulunmamaktadır.</MDTypography>
      <MDTypography variant="body2" color="text">6.2. Tüketici konumundaki ALICI, Abonelik Sözleşmeleri Yönetmeliği m.22 uyarınca aboneliğini dilediği zaman feshedebilir. Peşin ödemelerde kullanılmayan süreye ilişkin bedel, fesih talebinden itibaren 14 gün içinde iade edilir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 7. Fikri Mülkiyet Hakları */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        7. Fikri Mülkiyet Hakları
      </MDTypography>
      <MDTypography variant="body2" color="text">7.1. Platform, yazılım, kaynak kod, marka, logo ve tüm içerik üzerindeki haklar LogicaDx’e aittir.</MDTypography>
      <MDTypography variant="body2" color="text">7.2. ALICI yazılımı çoğaltamaz, değiştiremez, tersine mühendislik yapamaz, kiralayamaz veya üçüncü kişilere devredemez.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 8. Sorumluluk ve Hizmetin Kapsamı */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        8. Sorumluluk ve Hizmetin Kapsamı
      </MDTypography>
      <MDTypography variant="body2" color="text">8.1. SATICI, kesintisiz hizmet sağlamak için özen gösterir; ancak internet/elektrik kesintileri, ağ ve altyapı arızaları gibi dış etkenlerden sorumlu tutulamaz.</MDTypography>
      <MDTypography variant="body2" color="text">8.2. Hizmet, ALICI’ya Veri Koruma Mevzuatı’na uyum için teknik araçlar sağlar; hukuki uyum ve içerik sorumluluğu tamamen ALICI’ya aittir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 9. Ayıplı Hizmet */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        9. Ayıplı Hizmet
      </MDTypography>
      <MDTypography variant="body2" color="text">9.1. 6502 sayılı Kanun uyarınca ayıplı hizmet halinde ALICI; hizmetin yeniden ifasını, ayıp oranında bedel indirimi, sözleşmeden dönme veya ücretsiz onarım talep edebilir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 10. Uyuşmazlıkların Çözümü */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        10. Uyuşmazlıkların Çözümü
      </MDTypography>
      <MDTypography variant="body2" color="text">10.1. Şikâyet ve talepler: info@logicookie.com</MDTypography>
      <MDTypography variant="body2" color="text">10.2. Tüketici işlemlerinde, uyuşmazlık değerine göre Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri; ticari kullanıcılar bakımından İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 11. Yürürlük */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        11. Yürürlük
      </MDTypography>
      <MDTypography variant="body2" color="text">11.1. ALICI’nın elektronik onayıyla işbu sözleşme kurulmuş ve yürürlüğe girmiştir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* (EK) Ön Bilgilendirme Formu */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        (EK) Ön Bilgilendirme Formu
      </MDTypography>
      <MDTypography variant="body2" color="text"><strong>Satıcı:</strong> LogicaDx Bilişim Danışmanlık — Adres: Barbaros Mah. Ihlamur Blv. No:3 İç Kapı No:15 Ataşehir/İstanbul — VKN: 7960516854 — E-posta: info@logicookie.com</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Hizmet:</strong> LogiCookie dijital çerez yönetimi SaaS (anında ifa).</MDTypography>
      <MDTypography variant="body2" color="text">
        <strong>Plan/Bedel:</strong>{" "}
        {planName && durationLabel && subtotalText && vatText && totalText
          ? `${planName} – ${durationLabel} – ${subtotalText} + ${vatText} = ${totalText} TL`
          : "Plan – Süre – Fiyat + KDV = Toplam TL"}
      </MDTypography>
      <MDTypography variant="body2" color="text"><strong>Ödeme:</strong> Kredi/banka kartı (peşin).</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Teslim/İfa:</strong> Dijital erişim ile anında ifa.</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Cayma Hakkı:</strong> Mesafeli Sözleşmeler Yönetmeliği m.15/1-ğ gereği cayma hakkı yoktur (anında ifa).</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Abonelik ve Fesih (Tüketici):</strong> Abonelik Sözleşmeleri Yön. m.22 uyarınca her zaman fesih; peşin ödemede kullanılmayan kısım 14 gün içinde iade edilir.</MDTypography>
      <MDTypography variant="body2" color="text"><strong>Uyuşmazlık:</strong> Değer sınırlarına göre Tüketici Hakem Heyetleri/Tüketici Mahkemeleri.</MDTypography>
    </MDBox>
  );
}

export default SalesAgreement;
